import { MockTest } from 'src/app/utils/mock-test';
import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Subject, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DividasSerasa } from "src/app/models/dividasPendentes/dividas-serasa";

@Injectable({
  providedIn: 'root'
})
export class BlocoDividasSerasaService {
  public avisosDividas : Subject<DividasSerasa>;

  constructor(public http: HttpClient) {
    this.avisosDividas = new Subject<DividasSerasa>();
  }

  consultarInformacoesNegativasRefin(): Promise<any> {
    if (environment.name == 'local') {
        let dados = MockTest.criarMockDividasPendentesRefin();
        return of(MockTest.criarMockHttp(dados, '200')).toPromise();
    }
    return this.http.get(environment.url + '/lgpd/sintetico/v1/negativo/refin').toPromise();
  }

  consultarInformacoesNegativasPefin(): Promise<any> {
    if (environment.name == 'local') {
        let dados = MockTest.criarMockDividasPendentesPefin();
        return of(MockTest.criarMockHttp(dados, '200')).toPromise();
    }
    return this.http.get(environment.url + '/lgpd/sintetico/v1/negativo/pefin').toPromise();
  }

  consultarInformacoesNegativasConvem(): Promise<any> {
    if (environment.name == 'local') {
        let dados = MockTest.criarMockDividasPendentesConvem();
        return of(MockTest.criarMockHttp(dados, '200')).toPromise();
    }
    return this.http.get(environment.url + '/lgpd/sintetico/v1/negativo/convem').toPromise();
  }

  getAvisosDividas(): Subject<DividasSerasa> {
    return this.avisosDividas;
  }
}
